import { createReducer } from "@reduxjs/toolkit";
import {
  RIVERS_GET_ALL,
  RIVERS_GET_BY_ID,
  RIVERS_ADD,
  RIVERS_UPDATE,
  RIVERS_DELETE,
} from "./action";
import { River } from "src/types/river";

export type RiverState = {
  rivers: River[];
  selectedRiver: River | null;
};

export const initialState: RiverState = {
  rivers: [],
  selectedRiver: null,
};

const riverReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(RIVERS_GET_ALL, (state, action) => {
      state.rivers = action.payload.rivers;
    })
    .addCase(RIVERS_GET_BY_ID, (state, action) => {
      state.selectedRiver = action.payload.river;
    })
    .addCase(RIVERS_ADD, (state, action) => {
      state.rivers.push(action.payload.river);
    })
    .addCase(RIVERS_UPDATE, (state, action) => {
      const updated = action.payload.river;
      state.rivers = state.rivers.map((r) =>
        r.riverId === updated.riverId ? updated : r
      );
    })
    .addCase(RIVERS_DELETE, (state, action) => {
      state.rivers = state.rivers.filter(
        (r) => r.riverId !== action.payload.riverId
      );
    })
);

export default riverReducer;
